<script setup lang="ts">
import Capsule from '@/components/common/Capsule.vue'
import ArrotexOfferPoduct, { type Product } from './ArrotexOfferPoduct.vue'
import type { PropType } from 'vue'

defineProps({
  data: {
    type: Array as PropType<Product[]>,
    required: true
  },
  background: {
    type: String as PropType<'light' | 'dark'>,
    default: 'light'
  },
  backgroundGlow: {
    type: String as PropType<'first' | 'last'>,
    default: 'first'
  }
})
</script>

<template>
  <Capsule
    :isMain="false"
    mode="horizontal"
    :children-count="data.length"
    :background="background"
    :class="{ first: backgroundGlow === 'first', last: backgroundGlow === 'last' }"
  >
    <template v-for="(dataItem, index) in data" :key="index" #[index+1]>
      <ArrotexOfferPoduct
        :data="dataItem"
        :first="index === 0"
        :last="data.length === index + 1"
      ></ArrotexOfferPoduct>
    </template>
  </Capsule>
</template>

<style scoped></style>
